module.exports = __webpack_public_path__ + "img/06-silo-base-day.1ed137b4.png";